import React from 'react';
import styled from 'styled-components';

type DateInputProps = {
  value: string | Date | null;
  onChange: (value: Date | null) => void;
  disabled?: boolean;
  className?: string;
};

export const DateInput: React.FC<DateInputProps> = ({ value, onChange, disabled, className }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    if (!raw) {
      onChange(null);
    } else {
      const parsed = new Date(raw + 'T00:00:00');
      if (!isNaN(parsed.getTime())) {
        onChange(parsed);
      }
    }
  };

  const inputValue =
    value instanceof Date
      ? value.toISOString().slice(0, 10)
      : typeof value === 'string' && value !== ''
        ? new Date(value + 'T00:00:00').toISOString().slice(0, 10)
        : '';

  return (
    <input
      type="date"
      value={inputValue}
      onChange={handleChange}
      disabled={disabled}
      className={className}
    />
  );
};

export const StyledDateInput = styled(DateInput)<{ hasValue: boolean }>`
  color: ${({ hasValue }) => (hasValue ? '#222' : '#bbb')};
  padding: 4px;
  border: 1px solid #ddd;
  border-radius: 4px;
`;
